import { create } from 'zustand';

type OnboardingDialogState = {
  isOpen: boolean;
  // Bumped on each open so the conversation remounts and re-fetches.
  sessionKey: number;
  /** Unsent composer text. Held here because closing the panel unmounts the composer. */
  draft: string;
  /**
   * Whether the step list has been pushed aside in favour of the conversation.
   *
   * Session state rather than a stored preference: it is set by asking a question, not by choosing
   * anything. It lives here rather than in the pane so that hiding the panel and opening it again
   * comes back to whichever of the two the user was last looking at.
   */
  isChecklistDismissed: boolean;
  open: () => void;
  close: () => void;
  setDraft: (draft: string) => void;
  dismissChecklist: () => void;
  restoreChecklist: () => void;
};

export const useOnboardingDialogStore = create<OnboardingDialogState>((set) => ({
  isOpen: false,
  sessionKey: 0,
  draft: '',
  isChecklistDismissed: false,
  open: () => set((state) => ({ isOpen: true, sessionKey: state.sessionKey + 1 })),
  close: () => set({ isOpen: false }),
  setDraft: (draft) => set({ draft }),
  dismissChecklist: () => set({ isChecklistDismissed: true }),
  restoreChecklist: () => set({ isChecklistDismissed: false }),
}));
